import {
    FETCH_PRODUCTION_STATISTICS_BY_STATION,
    FETCH_SERVICE_ORDER_PRODUCTION_STATISTICS,
    FETCH_SERVICE_ORDER_TIRE_STATISTICS,
    RECEIVE_PRODUCTION_STATISTICS_BY_STATION,
    RECEIVE_SERVICE_ORDER_PRODUCTION_STATISTICS,
    RECEIVE_SERVICE_ORDER_TIRE_STATISTICS,
    POST_SUCCESS_SERVICE_ORDER,
    POST_SERVICE_ORDER, POST_SERVICE_ORDER_STEP, POST_SUCCESS_SERVICE_ORDER_STEP
} from "./actionTypes";
import axios from '../axiosApi';


export const dpFetchProductionStatistics =  () => ({
    type: FETCH_SERVICE_ORDER_PRODUCTION_STATISTICS
});

export const dpFetchTireStatistics =  () => ({
    type: FETCH_SERVICE_ORDER_TIRE_STATISTICS
});

export const dpReceiveProductionStatistics = payload => ({
    type: RECEIVE_SERVICE_ORDER_PRODUCTION_STATISTICS,
    payload: payload
});

export const dpReceiveTireStatistics = payload => ({
    type: RECEIVE_SERVICE_ORDER_TIRE_STATISTICS,
    payload: payload
});

export const dpPostServiceOrder =  () => ({
  type: POST_SERVICE_ORDER
});

export const dpPostSuccessServiceOrder =  () => ({
  type: POST_SUCCESS_SERVICE_ORDER
});


export const dpPostServiceOrderStep =  () => ({
    type: POST_SERVICE_ORDER_STEP
});

export const dpPostSuccessServiceOrderStep =  () => ({
    type: POST_SUCCESS_SERVICE_ORDER_STEP
});



export const getSOProductionStatistics = () => {
    return async (dispatch, getState) => {
        dispatch(dpFetchProductionStatistics());

        let productionTotals;
        let productionByHour;
        let productionByDate;
        let avgTimeToWaitPerOperator;
        let payload;

        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

        try {
            let options1 = {
                "Interval": {
                    "Min": periodMin,
                    "Max": periodMax
                },
                "IntervalComparasion": {
                    "Min": beforeperiodMin,
                    "Max": beforeperiodMax
                },
                "IntervalBenchmark": {
                    "Min": benchperiodMin,
                    "Max": benchperiodMax
                }
            }
            const response1 = await axios.post(`/ServiceOrders/ProductionStatistics`, options1)
            productionTotals = response1.data;

            const response2 = await axios.post(`/ServiceOrders/ProductionByHour`, options1)
            productionByHour = response2.data

            const response3 = await axios.post(`/ServiceOrders/ProductionByDate`, options1)
            productionByDate = response3.data

            const response4 = await axios.post(`/ServiceOrders/AvgRaspaTimeToWaitPerOperator`, options1)
            avgTimeToWaitPerOperator = response4.data

        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            payload = {
                productionTotals: productionTotals,
                productionByHour: productionByHour,
                productionByDate: productionByDate,
                avgTimeToWaitPerOperator: avgTimeToWaitPerOperator
            }

            dispatch(dpReceiveProductionStatistics(payload));
        }
    }
};

export const getSOTiresStatistics = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }

        dispatch(dpFetchTireStatistics());

        let tireBrands;
        let tireModels;
        let tireBands;
        let tireSizes;
        let payload;

        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

        try {
            let options1 = {
                "Interval": {
                    "Min": periodMin,
                    "Max": periodMax
                },
                "IntervalComparasion": {
                    "Min": beforeperiodMin,
                    "Max": beforeperiodMax
                },
                "IntervalBenchmark": {
                    "Min": benchperiodMin,
                    "Max": benchperiodMax
                }
            }
            const response1 = await axios.get(`/ordem-servicos/pneu-marcas?intervalo={"min":"${options1.Interval.Min}","max":"${options1.Interval.Max}"}`)
            tireBrands = response1.data;
            const response2 = await axios.get(`/ordem-servicos/pneu-modelos?intervalo={"min":"${options1.Interval.Min}", "max":"${options1.Interval.Max}"}`)
            tireModels = response2.data;
            const response3 = await axios.get(`/ordem-servicos/bandas?intervalo={"min":"${options1.Interval.Min}","max":"${options1.Interval.Max}"}`)
            tireBands = response3.data;
            const response4 = await axios.get(`/ordem-servicos/pneu-medidas?intervalo={"min":"${options1.Interval.Min}","max":"${options1.Interval.Max}"}`)
            tireSizes = response4.data;

            console.log("LOGLOGLOG", response2.data);

        }
        catch(e) {
          //  console.log("ERROR os.estatisticas", e);
            payload = { error: true };
        }
        finally {

            payload = {
                tireBrands: tireBrands,
                tireModels: tireModels,
                tireBands: tireBands,
                tireSizes: tireSizes
            }

            dispatch(dpReceiveTireStatistics(payload));
        }
    }
};

export const addServiceOrders = (data) => {
  return async dispatch => {
    dispatch(dpPostServiceOrder());
    let payload;
    try {
      const response = await axios.post(`/ServiceOrders`, data)
      payload = response.data
    }
    catch(e) {
      payload = { error: true };
    }
    finally {
      dispatch(dpPostSuccessServiceOrder(payload));
    }
  }
}

export const addServiceOrderVulcanizationStep = (data) => {
    return async dispatch => {
        dispatch(dpPostServiceOrderStep());
        let payload;
        try {
            const response = await axios.post(`/ServiceOrderStep`, data)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(dpPostSuccessServiceOrderStep(payload));
        }
    }
}
